import { useMemo } from "react";
import { getOsTypeFromAgent } from "@inferno/renderer-shared-core";
import { COAST_SHOW_TYPE } from "../../../lib/coastContent";
import { CoastShowPayloadFields } from "../CoastContent.types";
import "./CoastShowAudioBox.style.scss";
import { CoastShowAudioboxABVLoader } from "./CoastShowAudioboxABV.component";
import { CoastShowAudioboxHighlightsLoader } from "./CoastShowAudioboxHighlights.component";
import { CoastShowAudioboxMP3Loader } from "./CoastShowAudioboxMP3.component";
import { parseCoastMediaIds } from "./util";

interface CoastShowAudioBoxComponentProps {
  showDate: Date | number;
  showType: COAST_SHOW_TYPE;
  show: CoastShowPayloadFields;
}

export const CoastShowAudioBoxComponent = ({ showDate, showType, show }: CoastShowAudioBoxComponentProps) => {
  const osType = useMemo(() => getOsTypeFromAgent(), []);

  const episodesIds = useMemo(() => parseCoastMediaIds(show.zype_episodes?.value), [show.zype_episodes?.value]);
  const highlightsIds = useMemo(() => parseCoastMediaIds(show.highlights?.value), [show.highlights?.value]);

  if (showType === COAST_SHOW_TYPE.UPCOMING || (showType === COAST_SHOW_TYPE.ART_BELL_VAULT && !episodesIds.length)) {
    return null;
  }

  return (
    <>
      <section className="coast-show-audiobox-component">
        {showType === COAST_SHOW_TYPE.ART_BELL_VAULT || showType === COAST_SHOW_TYPE.SOMEWHERE_IN_TIME ? (
          <CoastShowAudioboxABVLoader showType={showType} episodes={episodesIds} />
        ) : null}

        {showType === COAST_SHOW_TYPE.REGULAR ? (
          <CoastShowAudioboxMP3Loader showType={showType} osType={osType} showDate={showDate} show={show} />
        ) : null}
      </section>
      <section className="audiobox-highlights">
        {showType === COAST_SHOW_TYPE.REGULAR || showType === COAST_SHOW_TYPE.CLASSIC ? (
          <CoastShowAudioboxHighlightsLoader highlightsIds={highlightsIds} osType={osType} />
        ) : null}
      </section>
    </>
  );
};

export default CoastShowAudioBoxComponent;
